(() => {
  if (document.documentElement.dataset.deoroJourneyReady) return;
  document.documentElement.dataset.deoroJourneyReady = 'true';

  const tryonHosts = new Set([
    'deoro-cuban-tryon.mwpromgmt.chatgpt.site',
    'deoro-cuban-bracelet-tryon.mwpromgmt.chatgpt.site'
  ]);
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function campaignUrl(raw) {
    try {
      const url = new URL(raw, window.location.origin);
      const internalJourney = url.origin === window.location.origin && /^\/(?:es\/)?products\/(?:cuban-chain-fit-kit|cadena-cubana-de-oro-solido|solid-gold-cuban-chain)\/?$/.test(url.pathname);
      if (url.protocol !== 'https:' || (!tryonHosts.has(url.hostname) && !internalJourney)) return raw;
      const incoming = new URLSearchParams(window.location.search);
      campaignKeys.forEach(key => {
        const value = incoming.get(key);
        if (value && value.length <= 200 && /^[\w .|{}:,+-]+$/.test(value)) {
          url.searchParams.set(key, value);
        }
      });
      return url.href;
    } catch (_) {
      return raw;
    }
  }

  function decorate() {
    document.querySelectorAll('a[href], iframe[data-src]').forEach(element => {
      const attribute = element.tagName === 'A' ? 'href' : 'data-src';
      const raw = element.getAttribute(attribute);
      if (!raw) return;
      const next = campaignUrl(raw);
      if (next !== raw) element.setAttribute(attribute, next);
    });
  }

  function sendEvent(name, entry) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        !privacy.analyticsProcessingAllowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, {
      send_to: 'G-WGEQP8P6W7',
      journey_entry: entry
    });
  }

  decorate();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const modalButton = event.target.closest('.deoro-tryon__button');
    if (modalButton) {
      decorate();
      sendEvent('deoro_tryon_open', 'embedded');
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const raw = link.getAttribute('href');
    const next = campaignUrl(raw);
    if (next !== raw) link.setAttribute('href', next);
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && /\/products\/cuban-chain-fit-kit\/?$/.test(url.pathname)) {
        sendEvent('deoro_fitkit_open', 'storefront');
      }
    } catch (_) {}
  }, true);
})();
